import React from "react";
import ReactDOM from "react-dom/client";
import App from "../App";

if (typeof window !== "undefined" && "serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((registrations) => {
      registrations.forEach((registration) => {
        void registration.unregister();
      });
    })
    .catch((error) => {
      console.warn("[OrthoPrecision] service worker cleanup failed", error);
    });
}

if (typeof window !== "undefined" && "caches" in window) {
  caches.keys()
    .then((keys) => Promise.all(keys.map((key) => caches.delete(key))))
    .catch((error) => {
      console.warn("[OrthoPrecision] cache cleanup failed", error);
    });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
